<template>
	<div>
		<h1 class="vrnu-headline">Gutscheine</h1>
    <vrnu-text-box v-bind:variant="'info'">
      Über die Gutscheinverwaltung können Gutscheine angelegt, bearbeitet und gelöscht werden.
      Jeder Gutschein ist einem Anbieter zugeordnet. Über die Felder "Gültig von" und "Gültig bis" kann die Anzeigedauer des Gutscheins in der App begrenzt werden.
      Über den Export-Button [<span class="icon-download"></span>] kann der individuelle Anbieter QR-Code des Gutscheins heruntergeladen werden.
    </vrnu-text-box>
	<b-button 	v-if="$auth.check(['user', 'superadmin'])"
				class="vrnu-button"
				v-on:click="exportRedemptions">
		<span class="icon-download"></span>&nbsp;&nbsp;Statistik herunterladen
	</b-button>
	<div class="space10"></div>
    <vrnu-list-wizard 	v-bind:listData="listData"
							v-on:delete="deleteCoupon"
							v-on:saveSuccess="saveSuccess"
							v-on:saveError="saveError"
							v-on:exportCode="exportCode"></vrnu-list-wizard>
							
		<!-- Info modal -->
		<b-modal ref="infoModal" centered hide-footer title="Info">
			<p>{{ infoModalMessage }}</p>
			<slot name="modal-ok">
				<b-button class="vrnu-button" v-on:click="$refs.infoModal.hide()">Ok</b-button>
			</slot>
	    </b-modal>	    
	</div>
</template>

<script>
// Organize imports
import ListWizard from '@/components/99_wizards/ListWizard';

export default {
	data: function() {
		return {
			coupons: [],
			infoModalMessage: null,
			listData: {
				name: "Gutschein",
				confirmAttribute: 'title',
				formModule: 'vrnu-coupons-form',
				viewModule: 'vrnu-coupons-view',
				target: 'coupons',
				pagination: true,
				filter: true,
				fields: [
					{
						key: 'title',
						label: 'Titel',
						sortable: true,					
					},
					{
						key: 'active',
						label: 'Aktiv',
						sortable: true,
						formatter: function(value) {
							if(value == true) {
								return "Ja";
							} else {
								return "Nein";
							}
						},
					},
					{
						key: 'provider',
						label: 'Anbieter',
						sortable: true,
						formatter: function(value) {
							return value.name;								
						},
					},
				],
				actions: [
					{
						type: 'view',
						text: 'Gutschein anzeigen',
						icon: 'icon-eye',
					},
					{
						type: 'update',
						text: 'Gutschein bearbeiten',
						icon: 'icon-pencil',
					},
					{
						type: 'custom',
						text: 'Gutscheincode exportieren',
						icon: 'icon-download',
						emit: 'exportCode',
					},
					{
						type: 'delete',
						text: 'Gutschein löschen',
						icon: 'icon-trash',
					},
				],
			},
		};
	},
	methods: {
		getCoupons: function() {
			// Get providers from server
			this.$http.get('coupons').then(coupons => {
				this.coupons = coupons.body;
			}, response => {
				this.providers = "Es ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Systemadministrator!";
			});
		},
		deleteCoupon: function(id) {
			// Get coupons from server
			this.$http.delete('coupons/' + id).then(response => {
				var couponTitle = response.body.title;
				this.openInfoModal("Der Gutschein \"" + couponTitle + "\" wurde erfolgreich gelöscht.");
			}, response => {
				this.openInfoModal("Beim Löschen des Gutscheins ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Systemadministrator.");
			});
		},
		exportCode: function(id) {
			// Get PDF from server
			this.$http.get("qr/createCouponQr/" + id, {responseType: 'arraybuffer'}).then(function(response) {
				var headers = response.headers;
				var blob = new Blob([response.data],{type:headers['content-type']});
				var link = document.createElement('a');
				link.href = window.URL.createObjectURL(blob);
				link.download = id + ".pdf";
				link.click();
			});
		},
		saveSuccess: function(result) {
			this.openInfoModal("Der Gutschein \"" + result.body.title + "\" wurde erfolgreich gespeichert.");
		},
		saveError: function(response) {
			this.openInfoModal("Beim Speichern des Gutscheins ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Systemadministrator.");
		},
		openInfoModal: function(message) {
			this.infoModalMessage = message;
			this.$refs.infoModal.show();
		},
		exportRedemptions: function() {
			this.$http.get('redemptions/exportRedemptions').then(response => {
				// Get current date
				var today = new Date();
				var dd = String(today.getDate()).padStart(2, '0');
				var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
				var yyyy = today.getFullYear();
				var filename = "Export-" + yyyy + "-" + mm + "-" + dd;

				// Create export file
				var headers = response.headers;
				var blob = new Blob([response.data],{type:headers['content-type']});
				var link = document.createElement('a');
				link.href = window.URL.createObjectURL(blob);
				link.download = filename + ".csv";
				link.click();
			}, response => {
				this.openInfoModal("Beim Erstellen des Exports ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Systemadministrator.");
			});

			/*
			this.$http.get("qr/createCouponQr/" + id, {responseType: 'arraybuffer'}).then(function(response) {
				var headers = response.headers;
				var blob = new Blob([response.data],{type:headers['content-type']});
				var link = document.createElement('a');
				link.href = window.URL.createObjectURL(blob);
				link.download = id + ".pdf";
				link.click();
			});
			*/
		},
	},
	created: function() {
		// Get coupons from server and display them
		this.getCoupons();
	},
	components: {
		'vrnu-list-wizard': ListWizard,
	}
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/04_coupon/Coupons.vue